document.addEventListener("DOMContentLoaded", function() {
  const toggleBtn = document.getElementById('ReadMoreToggle');
  const container = document.getElementById('FounderBioContainer');

  if (toggleBtn && container) {
    toggleBtn.addEventListener('click', function() {
      // Toggle the expanded class
      const isExpanded = container.classList.toggle('is-expanded');
      
      // Change the button text based on the state
      const btnText = toggleBtn.querySelector('.btn-text');
      
      if (isExpanded) {
        btnText.textContent = 'SHOW LESS';
      } else {
        btnText.textContent = 'READ FULL STORY';
        
        // Optional: Scrolls the user back up to the founder name 
        // so they don't get lost when the content shrinks.
        container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
});